import { FilterValueType } from '../api';
import { Dict } from '../models';

export const getFilters = (filters: Dict<FilterValueType>): Dict<any> => {
  const out: Dict = {};
  Object.keys(filters).forEach((key) => {
    if (key) {
      const val = filters[key];
      if (val) {
        out[key] = Array.isArray(val) ? val.map((v) => v.value) : val.value;
      }
    }
  });
  return out;
};
